module.exports = __webpack_public_path__ + "media/img/google-4d79cb3f81bb5748ab1dcc7f3905ddf3.png";